(function () {
  'use strict';

  var PROGRAMS = {
    '4months': {
      id: 41552728686650,
      sellingPlan: null,
      label: '4 Month Program — €516'
    },
    '12months': {
      id: 41552728719418,
      sellingPlan: null,
      label: '12 Month Program — €1,188'
    },
    '4x297': {
      id: 41552728752186,
      sellingPlan: 2796585018,
      label: '12 Month Program — 4 × €297'
    }
  };

  function rootUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function setLoading(button, loading) {
    if (loading) {
      if (!button.dataset.originalHtml) {
        button.dataset.originalHtml = button.innerHTML;
      }
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Adding…';
    } else {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if (button.dataset.originalHtml) {
        button.innerHTML = button.dataset.originalHtml;
      }
    }
  }

  function readResponse(response) {
    return response.text().then(function (text) {
      var data = {};
      try {
        data = text ? JSON.parse(text) : {};
      } catch (error) {
        throw new Error('Shopify returned an unreadable response.');
      }
      if (!response.ok) {
        throw new Error(
          data.description ||
          data.message ||
          'Shopify rejected the cart request (' + response.status + ').'
        );
      }
      return data;
    });
  }

  function createMiniCart() {
    var existing = document.getElementById('gfeel-mini-cart');
    if (existing) {
      return existing;
    }

    var widget = document.createElement('div');
    widget.id = 'gfeel-mini-cart';
    widget.innerHTML =
      '<button type="button" class="gf-mini-close" aria-label="Close">×</button>' +
      '<div class="gf-mini-check">✓</div>' +
      '<div class="gf-mini-copy">' +
        '<strong>Added to your cart</strong>' +
        '<span class="gf-mini-product"></span>' +
      '</div>' +
      '<div class="gf-mini-actions">' +
        '<a class="gf-mini-view" href="' + rootUrl() + 'cart">View cart</a>' +
        '<a class="gf-mini-checkout" href="' + rootUrl() + 'checkout">Checkout</a>' +
      '</div>';

    document.body.appendChild(widget);

    if (!document.getElementById('gfeel-mini-cart-styles')) {
      var style = document.createElement('style');
      style.id = 'gfeel-mini-cart-styles';
      style.textContent =
        '#gfeel-mini-cart{position:fixed;top:24px;right:24px;z-index:2147483000;' +
        'width:min(380px,calc(100vw - 32px));padding:22px;' +
        'border:1px solid rgba(30,232,160,.5);border-radius:18px;background:#0a0a0a;' +
        'color:#fff;box-shadow:0 20px 60px rgba(0,0,0,.55);font-family:inherit;' +
        'opacity:0;visibility:hidden;transform:translateY(-16px);' +
        'transition:opacity .25s ease,transform .25s ease,visibility .25s ease;}' +
        '#gfeel-mini-cart.is-open{opacity:1;visibility:visible;transform:translateY(0);}' +
        '#gfeel-mini-cart .gf-mini-close{position:absolute;top:10px;right:12px;' +
        'width:34px;height:34px;padding:0;border:0;background:transparent;' +
        'color:#aaa;font-size:27px;line-height:1;cursor:pointer;}' +
        '#gfeel-mini-cart .gf-mini-check{display:flex;align-items:center;justify-content:center;' +
        'width:42px;height:42px;margin-bottom:14px;border-radius:50%;' +
        'background:#1ee8a0;color:#07120e;font-size:22px;font-weight:800;}' +
        '#gfeel-mini-cart .gf-mini-copy{display:flex;flex-direction:column;gap:6px;padding-right:30px;}' +
        '#gfeel-mini-cart .gf-mini-copy strong{font-size:18px;line-height:1.3;}' +
        '#gfeel-mini-cart .gf-mini-product{color:#aaa;font-size:14px;line-height:1.5;}' +
        '#gfeel-mini-cart .gf-mini-actions{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-top:18px;}' +
        '#gfeel-mini-cart .gf-mini-actions a{display:flex;align-items:center;justify-content:center;' +
        'min-height:46px;padding:10px 14px;border-radius:999px;' +
        'font-size:14px;font-weight:800;text-decoration:none;}' +
        '#gfeel-mini-cart .gf-mini-view{border:1px solid rgba(255,255,255,.25);color:#fff;}' +
        '#gfeel-mini-cart .gf-mini-checkout{border:1px solid #1ee8a0;background:#1ee8a0;color:#07120e;}' +
        '@media(max-width:600px){#gfeel-mini-cart{top:16px;right:16px;left:16px;width:auto;}}';
      document.head.appendChild(style);
    }

    widget.querySelector('.gf-mini-close').addEventListener('click', function () {
      widget.classList.remove('is-open');
    });

    return widget;
  }

  function showMiniCart(program) {
    var widget = createMiniCart();
    widget.querySelector('.gf-mini-product').textContent = program.label;
    widget.classList.add('is-open');
  }

  function refreshCartBubble() {
    return fetch(rootUrl() + '?sections=cart-icon-bubble', {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          return null;
        }
        return response.json();
      })
      .then(function (sections) {
        if (!sections || !sections['cart-icon-bubble']) {
          return;
        }
        var wrapper = document.createElement('div');
        wrapper.innerHTML = sections['cart-icon-bubble'];
        var newBubble = wrapper.querySelector('#cart-icon-bubble');
        var currentBubble = document.querySelector('#cart-icon-bubble');
        if (newBubble && currentBubble) {
          currentBubble.innerHTML = newBubble.innerHTML;
        }
      })
      .catch(function (error) {
        console.warn('Cart counter could not be refreshed:', error);
      });
  }

  function addProgram(button) {
var key = button.getAttribute('data-gfeel-variant');

    if (!program) {
      window.alert('Unknown program "' + (key || '') + '". Check data-gfeel-variant on this button.');
      return;
    }

    var item = { id: program.id, quantity: 1 };
    if (program.sellingPlan) {
      item.selling_plan = program.sellingPlan;
    }

    setLoading(button, true);

    fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [item] })
    })
      .then(readResponse)
      .then(function () {
        showMiniCart(program);
        refreshCartBubble();
        setLoading(button, false);
      })
      .catch(function (error) {
        console.error('g·feel cart error:', error);
        window.alert(error.message || 'The program could not be added to your cart.');
        setLoading(button, false);
      });
  }

function init(scope) {
  var container = scope || document;

  container
    .querySelectorAll('[data-gfeel-variant]')
    .forEach(function (button) {
      if (button.dataset.gfeelBound === 'true') {
        return;
      }

      button.dataset.gfeelBound = 'true';

      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        addProgram(button);
      });
    });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });
} else {
  init(document);
}

document.addEventListener('shopify:section:load', function (event) {
  init(event.target);
});

})();